import { ArrowUpRight, ShoppingBag } from "lucide-react";
import { Link } from "react-router-dom";
import { BOUTIQUE_ENABLED } from "@/lib/features";

export default function CTAFinal() {
  return (
    <section className="bg-ink text-pearl py-24 sm:py-32 grain relative overflow-hidden" data-testid="cta-final">
      <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: "radial-gradient(circle at 20% 30%, var(--shin-cobalt) 0%, transparent 40%), radial-gradient(circle at 80% 70%, var(--shin-gold) 0%, transparent 40%)",
      }} />
      <div className="relative max-w-5xl mx-auto px-6 sm:px-10 text-center">
        <div className="font-mono-overline text-pearl/40 mb-6">Le moment de basculer</div>
        <h2 className="font-serif text-4xl sm:text-6xl leading-[1.05] tracking-tight mb-8" data-testid="cta-final-title">
          Tu as passé assez de temps
          <br />
          <em className="text-pearl/55 not-italic font-light">à éteindre des incendies.</em>
        </h2>
        <p className="text-pearl/65 text-lg max-w-2xl mx-auto leading-relaxed mb-12">
          45 minutes pour poser un diagnostic. Aucune obligation. Juste un échange technique sur ton organisation et ses leviers.
        </p>
        <div className="flex flex-wrap gap-4 justify-center">
          <a href="/#diagnostic" className="btn-white" data-testid="cta-final-diagnostic">
            Réserver mon diagnostic gratuit <ArrowUpRight size={16} />
          </a>
          {BOUTIQUE_ENABLED && (
            <Link to="/boutique" className="btn-outline-white" data-testid="cta-final-boutique">
              <ShoppingBag size={16} /> Voir la boutique
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}
